/** Intervaly push upozorneni z JSON retezce (API); neplatny nebo prazdny vstup = []. */
export const parsujIntervaly = (json?: string | null): number[] => {
    if (!json) return [];
    try {
        const parsed = JSON.parse(json);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
};

/**
 * Pravidlo „typ ma push upozorneni“: prijemci nejsou NIKDO a je alespon jeden interval.
 * Intervaly jsou JSON retezec (typ z API) nebo pole cisel (stav formulare).
 */
export const maPushUpozorneni = (t: {
    notifikacePrijemci?: string | null;
    notifikaceIntervaly?: string | number[] | null;
}): boolean => {
    const intervaly = Array.isArray(t.notifikaceIntervaly)
        ? t.notifikaceIntervaly
        : parsujIntervaly(t.notifikaceIntervaly);
    return t.notifikacePrijemci !== 'NIKDO' && intervaly.length > 0;
};
